export function getPrimaryLabel (plan, canAccessStarterUpgrade) {
    if (plan === 'pendoFree' || canAccessStarterUpgrade) {
        return 'Explore upgrade options';
    }

    return 'Contact us';
}
